import { VStack } from '@chakra-ui/react'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'

export const PageWithNavBar = (props: { children?: any; colorPalette?: string }) => {
  return (
    <VStack
      align={'stretch'}
      bg={'colorPalette.bg'}
      gap={0}
      justify={'flex-start'}
      minHeight={'100vh'}
      width={'full'}
    >
      <ScoSiteNavBar />
      {props.children}
    </VStack>
  )
}

export const pageWithNavbar = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <PageWithNavBar>{page}</PageWithNavBar>
  }
  return Component
}
